import type { IContributionProjetRepository } from '../../domain/ports/IContributionProjetRepository';
import type { ContributionProjetDTO, CreerContributionInput } from '../dto/dtos';

export interface CreerContributionUseCaseInput extends CreerContributionInput {}
export interface CreerContributionOutput { contribution: ContributionProjetDTO; }

export class CreerContributionUseCase {
  constructor(private readonly repository: IContributionProjetRepository) {}

  async execute(input: CreerContributionUseCaseInput): Promise<CreerContributionOutput> {
    const response = await this.repository.creer(input);
    if (!response.succes || !response.data) throw new Error(response.message || 'Erreur lors de la création');
    return { contribution: response.data };
  }
}
